<!--<div class="card">-->
<!--  <div class="card-body">-->
<!--    <div class="row">-->
<!--      <div class="col-2"></div>-->
<!--      <div class="col-4">-->
<!--        <label>Package Name</label>-->
<!--        <input formControlName="packageName" class="form-control mb-2" placeholder="Package Name" type="text">-->
<!--        <label>Package Price</label>-->
<!--        <input formControlName="packageName" class="form-control mb-2" placeholder="Package Price" type="text">-->
<!--        <label>No Of Dates</label>-->
<!--        <input formControlName="packageName" class="form-control mb-2" placeholder="No of dates" type="text">-->
<!--        <label>Type</label>-->
<!--        <input formControlName="packageName" class="form-control mb-2" placeholder="Package Name" type="text">-->
<!--        <label>Promotion</label>-->
<!--        <input formControlName="packageName" class="form-control mb-2" placeholder="Promotion" type="text">-->
<!--      </div>-->
<!--      <div class="col-4">-->

<!--        <div class="custom-file" style="    margin-top: 30px;">-->

<!--          <input type="file" class="custom-file-input" (change)="fileChangeEvent($event)" id="inputGroupFile01"-->
<!--                 aria-describedby="inputGroupFileAddon01">-->
<!--          <label class="custom-file-label" for="inputGroupFile01">Choose file</label>-->
<!--        </div>-->
<!--        <image-cropper-->
<!--          class="rounded-sm"-->
<!--          (imageCropped)="imageCropped($event)"-->
<!--          (imageLoaded)="imageLoaded()"-->
<!--          [alignImage]="'center'"-->
<!--          [aspectRatio]="4 / 3"-->
<!--          [cropperMinWidth]="340"-->
<!--          [imageChangedEvent]="imageChangedEvent"-->
<!--          [maintainAspectRatio]="true"-->
<!--          [onlyScaleDown]="true"-->
<!--          [resizeToWidth]="340"-->
<!--          [roundCropper]="false"-->
<!--          [style.display]="showCropper ? null : 'none'"-->
<!--          format="png"-->
<!--          outputType="file"-->
<!--        ></image-cropper>-->
<!--        <div class="font-size-lg text-center text-danger p-5" [hidden]="showCropper">-->
<!--          <h5 class="display-4 text-black mb-3 font-weight-bold">Cropped image</h5>-->
<!--          To see the image cropper in action, upload an image using the left form input.-->
<!--        </div>-->

<!--      </div>-->
<!--      <div class="col-2"></div>-->
<!--      <div class="col-2"></div>-->
<!--      <div class="col-8 text-right">-->
<!--        <button class="btn btn-info" (click)="firstnext()">Next</button>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<div class="card card-box">
  <div class="card-header">
    <div class="card-header--title">
      <small>Wizards</small>
      <b>Package Create</b>
    </div>
    <div class="card-header--actions">
      <!--      <a [routerLink]="" class="btn btn-sm btn-primary" tooltip="Dummy button">-->
      <!--        <fa-icon [icon]="['fas', 'plus']"></fa-icon>-->
      <!--      </a>-->
    </div>
  </div>
  <aw-wizard class="wizard">
    <aw-wizard-step stepTitle="Package information" [navigationSymbol]="{ symbol: '1' }">
      <div class="p-4">
        <h5 class="font-size-xl font-weight-bold">Package information</h5>
        <p class="text-black-50 mb-4">Try the keyboard navigation by clicking arrow left or right!</p>
        <form [formGroup]="packForm">
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="pname">Package Name</label>
              <input formControlName="packageName" class="form-control" id="pname" placeholder="Package Name"
                     type="text">
            </div>
            <div class="form-group col-md-6">
              <label for="pprice">Package Price</label>
              <input formControlName="packagePrice" class="form-control" id="pprice" placeholder="Package Price"
                     type="text">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-3">
              <label for="pdates">No Of Dates</label>
              <input formControlName="nodate" class="form-control" id="pdates" placeholder="No Of Dates" type="text">
            </div>
            <div class="form-group col-md-3">
              <label for="ptype">Type</label>
              <select id="ptype" formControlName="type" class="form-control mb-2" placeholder="Catagory" type="text">
                <option *ngFor="let c of type" value="{{c.id}}">{{c.type}}</option>
              </select>
            </div>
            <div class="form-group col-md-3" [hidden]="hidden()">
              <label for="ppro">Category</label>

              <select formControlName="categoryId" [disabled]="true" class="form-control mb-2" placeholder="Catagory" type="text">
                <option disabled value="x">Category</option>
                <option *ngFor="let c of catgorys" value="{{c.id}}">{{c.category}}</option>
              </select>
            </div>
            <div class="form-group col-md-3">
              <label for="ppro">Promotion</label>
              <select formControlName="promotion" id='ppro' class="form-control mb-2" placeholder="Promotion"
                      type="text">
                <option value="1">Promotion</option>
                <option value="0">Normal</option>
              </select>
            </div>

          </div>

          <div class="form-row">
            <div class="form-group col-md-12">
<!--              <div class="custom-file" style="    margin-top: 30px;">-->
<!--                <input type="file" class="custom-file-input" (change)="fileChangeEvent($event)" id="inputGroupFile01"-->
<!--                       aria-describedby="inputGroupFileAddon01">-->
<!--                <label class="custom-file-label" for="inputGroupFile01">Choose file</label>-->
<!--              </div>-->

              <ngx-dropzone (change)="onSelect($event)">
                <ngx-dropzone-label>Drop!</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
                  <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                </ngx-dropzone-preview>
              </ngx-dropzone>
            </div>
          </div>
        </form>
<!--        <div class="row">-->
<!--          <image-cropper-->
<!--            class="rounded-sm"-->
<!--            (imageCropped)="imageCropped($event)"-->
<!--            (imageLoaded)="imageLoaded()"-->
<!--            [alignImage]="'center'"-->
<!--            [aspectRatio]="4 / 3"-->
<!--            [cropperMinWidth]="340"-->
<!--            [imageChangedEvent]="imageChangedEvent"-->
<!--            [maintainAspectRatio]="true"-->
<!--            [onlyScaleDown]="true"-->
<!--            [resizeToWidth]="340"-->
<!--            [roundCropper]="false"-->
<!--            [style.display]="showCropper ? null : 'none'"-->
<!--            format="png"-->
<!--            outputType="file"-->
<!--          ></image-cropper>-->
<!--          <div class="font-size-lg text-center text-danger p-5" [hidden]="showCropper">-->
<!--            <h5 class="display-4 text-black mb-3 font-weight-bold">Cropped image</h5>-->
<!--            To see the image cropper in action, upload an image using the left form input.-->
<!--          </div>-->
<!--        </div>-->

      </div>
      <div class="actions p-4">
        <button [awGoToStep]="{stepIndex: 3}" class="btn btn-primary" type="button">Previous</button>
        <button awNextStep class="btn btn-primary" type="button" [disabled]="!packForm.valid" >Next</button>
      </div>
    </aw-wizard-step>
    <aw-wizard-step awOptionalStep stepTitle="Inclusions & Exclustions" [navigationSymbol]="{ symbol: '2' }">
      <div class="p-4">
        <h5 class="font-size-xl font-weight-bold">Inclusions & Exclustions information</h5>
        <p class="text-black-50 mb-4">Wonderful transition effects.</p>
        <div class="form-group">
          <div class="row">
            <div class="col-6">
              <label for="ind">Inclusions Description</label>
              <form [formGroup]="incluForm">
                <div class="input-group">
                  <input formControlName="inclue" class="form-control mb-3" id="ind"
                         placeholder="Inclusions Description" type="text">
                  <button class="btn btn-success" style="height: calc(1.5em + 1.06rem + 2px);" (click)="inclueAdd()">
                    add
                  </button>
                </div>
              </form>
              <table class="table table-hover text-nowrap table-borderless mb-0">
                <thead>
                <tr>
                  <th class="">DESCRIPTION</th>
                  <th class="text-center">ACTION</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let ex of incluArray" class="cusror-point" (click)="inclueClick(ex.description)">
                  <td class="font-weight-bold ">{{ex.description}}</td>
                  <td class="text-center">
                    <button type="button" class="btn btn-danger btn-sm " (click)="removeInclue(ex.description)">
                      <i class="far fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-6">
              <label for="exd"> Exclustions Description</label>
              <form [formGroup]="exclueForm">
                <div class="input-group">
                  <input formControlName="exclue" class="form-control mb-3" id="exd"
                         placeholder="Exclustions Description" type="text">
                  <button class="btn btn-success" style="height: calc(1.5em + 1.06rem + 2px);" (click)="exclueAdd()">
                    add
                  </button>
                </div>
              </form>
              <table class="table table-hover text-nowrap table-borderless mb-0">
                <thead>
                <tr>
                  <th class="">DESCRIPTION</th>
                  <th class="text-center">ACTION</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let ex of excluArray" class="cusror-point" (click)="exclueClick(ex.description)">
                  <td class="font-weight-bold ">{{ex.description}}</td>
                  <td class="text-center">
                    <button type="button" class="btn btn-danger btn-sm " (click)="removeExclue(ex.description)">
                      <i class="far fa-trash-alt"></i></button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>

        <div class="table-responsive">

        </div>

      </div>
      <div class="actions p-4">
        <button *awPreviousStep class="btn btn-primary" type="button">Previous</button>
        <button awPreviousStep *ngIf="isUpdate!='true'" class="btn btn-success" type="button" (click)="createPackage()">Create</button>
        <button awPreviousStep *ngIf="isUpdate=='true'" class="btn btn-warning" type="button" (click)="updatePackage()">Update</button>
      </div>
    </aw-wizard-step>
    <!--    <aw-wizard-step stepTitle="Itenary details" [navigationSymbol]="{ symbol: '3' }">-->
    <!--      <div class="p-4">-->
    <!--        <h5 class="font-size-xl font-weight-bold">Itenary details</h5>-->
    <!--        <p class="text-black-50 mb-4">The next and previous buttons help you to navigate through your content.</p>-->
    <!--        <div class="row">-->
    <!--          <div class="form-group col-12">-->
    <!--            <input class="form-control" placeholder="itenary" type="text">-->
    <!--          </div>-->
    <!--          <div class="form-group col-6">-->
    <!--            <input class="form-control" placeholder="About day" type="text">-->
    <!--          </div>-->
    <!--          <div class="form-group col-6">-->
    <!--            <input class="form-control" placeholder="About day" type="text">-->
    <!--          </div>-->

    <!--          <table class="table table-hover text-nowrap table-borderless mb-0">-->
    <!--            <thead>-->
    <!--            <tr>-->
    <!--              <th class="">DESCRIPTION</th>-->
    <!--              <th class="text-center">ACTION</th>-->
    <!--            </tr>-->
    <!--            </thead>-->
    <!--            <tbody>-->
    <!--            <tr class="cusror-point">-->
    <!--              <td class="font-weight-bold ">sdasdasdasd</td>-->
    <!--              <td class="text-center"><button type="button" class="btn btn-danger btn-sm " ><i class="far fa-trash-alt"></i></button></td>-->
    <!--            </tr>-->
    <!--            </tbody>-->
    <!--          </table>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="actions p-4">-->
    <!--        <button awPreviousStep class="btn btn-primary" type="button">Previous Step</button>-->
    <!--        <button (click)="finishWizard( 'danger', 'Youve reached the last wizard step successfully!' )"-->
    <!--                class="btn btn-primary" type="button">Finish-->
    <!--        </button>-->
    <!--      </div>-->
    <!--    </aw-wizard-step>-->
  </aw-wizard>
</div>

<notifier-container></notifier-container>
